import { useState } from "react";

import { Dialog } from "components/ui/Dialog";
import { CommunicationsTable } from "features/communications/components/CommunicationsTable/CommunicationsTable";
import { LettersSickCertsPanel } from "features/communications/components/LettersSickCertsPanel/LettersSickCertsPanel";
import { SickCertsSection } from "features/communications/components/SickCertsSection/SickCertsSection";
import { SmsModal2 } from "features/comunications/components/SmsModal2/SmsModal2";
import { SimplePatientPageLayout } from "features/patients/components/SimplePatientPageLayout/SimplePatientPageLayout";
import { useCurrentPatientId } from "features/patients/hooks/useCurrentPatientId";
import { usePatientData } from "features/patients/hooks/usePatientData";
import { usePatientSmsHistory } from "features/patients/hooks/usePatientSmsHistory";

import { CommunicationMenu as CommsMenu } from "../components/CommunicationMenu";
import { PatientsSmsTable as PatientSms } from "./components/PatientSms/PatientSms";

const PatientCommunicationPage = () => {
  const patientId = useCurrentPatientId();
  const { data: patient } = usePatientData();
  const {
    data: smsData,
    isLoading: isLoadingSms,
    refetch: refetchSms,
  } = usePatientSmsHistory(patientId);

  const tenantVal = localStorage.getItem("kinesin-tenant");

  const [activeSubMenu, setActiveSubMenu] = useState("SMS");
  const [isSmsModalOpen, setIsSmsModalOpen] = useState(false);

  const toggleSmsModal = () => {
    setIsSmsModalOpen((open) => !open);
    refetchSms();
  };

  const menuClick = (value) => {
    setActiveSubMenu(value);
    if (value === "SMS") refetchSms();
  };

  return (
    <>
      <SimplePatientPageLayout sidebar={<CommsMenu menuClick={menuClick} />}>
        {activeSubMenu === "EMAIL" ? (
          <CommunicationsTable
            patientId={patientId}
            hidePatientColumn
            hideSentByColumn
          />
        ) : activeSubMenu === "LETTERS" ? (
          <LettersSickCertsPanel patientId={patientId} patient={patient} />
        ) : activeSubMenu === "SICK CERTS" ? (
          <SickCertsSection patientId={patientId} patient={patient} />
        ) : (
          /* Always the table, which carries its own empty state — the separate
             illustration screen meant a patient with no messages got a different
             layout, with no heading and no way to reach the search. */
          <PatientSms
            handleClick={toggleSmsModal}
            smsList={smsData ?? []}
            isLoading={isLoadingSms}
          />
        )}
      </SimplePatientPageLayout>

      <Dialog
        onClose={toggleSmsModal}
        title="Send sms"
        width={1000}
        open={isSmsModalOpen}
      >
        <SmsModal2
          tenantVal={tenantVal}
          patient={patient}
          onClose={toggleSmsModal}
        />
      </Dialog>
    </>
  );
};

export { PatientCommunicationPage };
